// subscribeUserReplyPrice.js
'use strict';
import * as MessageTypes from '../serviceWorker/AppMessageTypes.js';
import { sendMessageToSW } from '../serviceWorker/helpers.js';
/**
 * Subscribe user reply price
 * @kind action
 * @param {string} {userId} - action param.
 * @return {Promise} Action promise.
 */
const subscribeUserReplyPrice =
  ({ userId }) =>
  async dispatch => {
    if (
      userId === undefined ||
      userId === 'undefined' ||
      userId.length !== 24
    ) {
      return dispatch({ type: '' });
    }

    const messageEvent = {
      type: MessageTypes.USER_REPLY_PRICE,
      payload: { userId },
    };
    sendMessageToSW(messageEvent);
  };

export default subscribeUserReplyPrice;
